import { Translation } from "../../hooks/useTranslations";
import { Entity, LanguageCode } from "../../types";
import { Role } from "../roles/types";

export type UserSalesRole = "ts" | "rsm" | "asm" | "dsm";

export type UserLight = {
  id: string;
  email?: string;
  fullName: string;
  currentCostCenter?: string;
};

export type Me = UserLight & {
  id: string;
  firstName: string;
  lastName: string;
  birthDate: string;
  distanceInMiles: boolean;
  drivingLicenseExpiration: string;
  currentCostCenter?: string;
  salesRole?: UserSalesRole;
  roles: Role[];
  permissions: string[];
  manager?: UserLight;
  department?: string;
  preferredLanguage: LanguageCode;
};

export type User = Entity &
  Me & {
    hasImportErrors: boolean;
    hidden: boolean;
    isRothoblaasUser: boolean;
    areNotificationsDisabled: boolean;
    userSubsidiariesIDs: string[];
    mileageEmailSentDate?: string;
  };

export type UpsertUser = {
  email?: string | null;
  firstName: string;
  lastName: string;
  birthDate?: string | null;
  distanceInMiles: boolean;
  hidden: boolean;
  isRothoblaasUser: boolean;
  areNotificationsDisabled: boolean;
};

export type UpsertRolesPermissions = {
  roles: Role[];
  permissions: string[];
  userSubsidiariesIDs?: string[];
};

export const formatSalesRoles = (i18n: Translation, salesRole: UserSalesRole): string => {
  switch (salesRole) {
    case "ts":
      return i18n.common.technicalSale;
    case "rsm":
      return i18n.common.regionSalesManager;
    case "asm":
      return i18n.common.areaSalesManager;
    case "dsm":
      return i18n.common.divisionSalesManager;
    default:
      return salesRole; // fallback if no match is found
  }
};
